module.exports = __webpack_public_path__ + "img/screenshot-schon.3d61563c.png";